import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';

import {
  Table, TableRow, TableCell, TableHead, TableBody
} from '@material-ui/core';
import { map } from 'lodash';


import { baseStyles, colors, patientGoalBaseStyles } from '../../theme/style';
import AdminLayout from '../user/admin/AdminLayout';
import AdminLayoutHelper from '../common/admin-layout-helper';
import { navigateTo, getTransferList } from '../../redux/actions';
import { Loading } from '../common';
import BackToPage from '../common/back-to-page';
import { urls } from '../../utils/Objects';
import Alerts from '../common/Alerts';



class PatientTransfers extends Component {
  state = {
    new: false,
    compliance_hours: '',
    serial_number: ''
  };

  componentDidMount() {
    if(this.props.selectedPatient)
    this.props.getTransferList(this.props.selectedPatient.id)
    else{

    }
  }
  
  
  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value })
  };
  
  // render()
  // {
    //   return <div/>
    // }
    
    render() {
      
      let birth_date_display = this.props.selectedPatient?.birthDate;
      if (this.props.user.patient.transferList != null) {
        
        return (<AdminLayout {...this.props}>
    <Alerts />
       {/* <AdminLayoutHelper header={name_display} page="Patient List" link="/admin"> */}
          
       <div navstyle={patientGoalBaseStyles.navstyle}>
          <BackToPage link={urls.patientDetails} text="Patient details"/>
        </div>
          
          <div style={baseStyles.birthDate}>
            Birth Date: &nbsp;
            {moment(birth_date_display).format('MMM D, YYYY')}
          </div>


          <div>
            <h2 style={baseStyles.dataUploads}>Data Uploads</h2>
            <Table style={baseStyles.table}>
              <TableHead>
                <TableRow>
                  <TableCell>Date</TableCell>
                  <TableCell>serial</TableCell>
                  <TableCell>firmware</TableCell>
                  <TableCell>os</TableCell>
                  <TableCell>app version</TableCell>
                  <TableCell>battery</TableCell>
                  <TableCell>records</TableCell>
                </TableRow>
              </TableHead>
              <TableBody style={baseStyles.body}>
                {this.props.user.patient.transferList.map((t, idx) => {
                  return (
                    <TableRow style={baseStyles.row} key={idx}>
                      <TableCell>{moment( t.timestamp).format('MM-DD-YYYY HH:mm')}</TableCell>
                      <TableCell>{t.serialNumber}</TableCell>
                      <TableCell>{t.firmware}</TableCell>
                      <TableCell>{t.os}</TableCell>
                      <TableCell>{t.appVersion}</TableCell>
                      <TableCell style={{ textAlign: 'right' }}>{t.battery}</TableCell>
                      <TableCell style={{ textAlign: 'right' }}>{t.recordCount}</TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>

          </div>
      </AdminLayout>);
    }
    else
      return <Loading />
  }
}


const mapStateToProps = (state, ownProps) => {
  const selectedPatient = ownProps.location.state;
  return (
    {
      login: state.login,
      user: state.user,
      selectedPatient: selectedPatient
    }
  )
}

const mapDispatchToProps = {
  getTransferList,
  navigateTo,
}

export default connect(mapStateToProps, mapDispatchToProps)(PatientTransfers)